import { Action } from '@ngrx/store';
import { Agency } from '../../services/agencies/agencies.model';

export const SWITCH_LANGUAGE = '[APP_STATE] SWITCH_LANGUAGE';
export const SET_AGENCIES = '[APP_STATE] SET_AGENCIES';
export const SELECT_AGENCY = '[APP_STATE] SELECT_AGENCY';
export const SWITCH_NEO_FRAME = '[APP_STATE] SWITCH_NEO_FRAME';
export const OPEN_NEO_FRAME = '[APP_STATE] OPEN_NEO_FRAME';
export const CLOSE_NEO_FRAME = '[APP_STATE] CLOSE_NEO_FRAME';
export const RELOAD_NEO_FRAME = '[APP_STATE] RELOAD_NEO_FRAME';
export const OPEN_ARGUS_FRAME = '[APP_STATE] OPEN_ARGUS_FRAME';
export const CLOSE_ARGUS_FRAME = '[APP_STATE] CLOSE_ARGUS_FRAME';

export class SwitchLanguage implements Action {
	readonly type = SWITCH_LANGUAGE;

	constructor(public payload: string) {}
}

export class SetAgencies implements Action {
	readonly type = SET_AGENCIES;

	constructor(public payload: Array<Agency>) {}
}

export class SelectAgency implements Action {
	readonly type = SELECT_AGENCY;

	constructor(public payload: Agency) {}
}

export class SwitchNeoFrame implements Action {
	readonly type = SWITCH_NEO_FRAME;
}

export class OpenNeoFrame implements Action {
	readonly type = OPEN_NEO_FRAME;

	constructor(public payload?: string) {}
}

export class CloseNeoFrame implements Action {
	readonly type = CLOSE_NEO_FRAME;
}

export class ReloadNeoFrame implements Action {
	readonly type = RELOAD_NEO_FRAME;
}

export class OpenARGUSFrame implements Action {
	readonly type = OPEN_ARGUS_FRAME;
}

export class CloseARGUSFrame implements Action {
	readonly type = CLOSE_ARGUS_FRAME;
}

export type All
	= SwitchLanguage
	| SetAgencies
	| SelectAgency
	| SwitchNeoFrame
	| OpenNeoFrame
	| CloseNeoFrame
	| ReloadNeoFrame
	| OpenARGUSFrame
	| CloseARGUSFrame;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/app-state.ts